<div [ngClass]="product.displayProduct ? 'products-container-body' : 'products-container-body-unavailable'">
  <div class="content-section">
    <div class="title">
      <h3> {{ product.name }}</h3>
      @if (product.productId === 'GL' && alternateProductsExist) {
        <p class="title-text">Automatically included in Business Owners Policy</p>
      }
    </div>
    <div class="info">
      @for (description of product.descriptions; track description) {
        <div class="about-container">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15px" height="13px" viewBox="0 0 15 13" version="1.1">
            <!-- Generator: sketchtool 64 (101010) - https://sketch.com -->
            <title>8F37A7C5-AFFA-45B2-ABA5-D52CAB82210C</title>
            <desc>Created with sketchtool.</desc>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
              <g id="1100-Standard-Quote" transform="translate(-560.000000, -446.000000)" [attr.stroke]="ccs.globalColor1" stroke-width="2">
                <g id="Product" transform="translate(538.000000, 331.000000)">
                  <g id="icon-check-mark-yellow" transform="translate(22.390279, 115.544913)">
                    <polyline id="Check-Copy-17" transform="translate(7.460000, 5.760000) rotate(-5.000000) translate(-7.460000, -5.760000) " points="1 6.355 4.93217391 10.52 13.92 1"/>
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <p class="about-container-text">{{description}}</p>
        </div>
      }
    </div>
    @if (checkForPartner()) {
      <div class="discount">
        @if (((product.productId === 'BOP') || (product.productId === 'GL'))) {
          <div class="discount-body">
            <p class="discount-body--title">{{discountInformation.discountInfo.productDiscount.title}}</p>
            @if ((product.productId === 'BOP')) {
              <p class="discount-body--text">{{discountInformation.discountInfo.productDiscount.bopText}}</p>
            }
            @if ((product.productId === 'GL')) {
              <p class="discount-body--text">{{discountInformation.discountInfo.productDiscount.glText}}</p>
            }
          </div>
        }
      </div>
    }
    @if (showUmbrellaError && product.productId == 'UMBRELLA') {
      <span class="umbrellaSelectionError">
        In order to add Umbrella coverage, please choose either
        Business Owners Policy or General
        Liability first.
        <span class="icon-close" (click)="closeMessage()">&#10005;</span>
      </span>
    }
    <div class="addCovg-btn">
      @if (product.displayProduct && (product.productId === 'CYBER-PROERM')) {
        <button class="addCovg-btn-btn" value="{{product.productId}}" [ngClass]="product.addCyberProduct ? 'Added' : 'Add'"
          (click)="selectCyberCovg(product)">
          {{ product.addCyberProduct ? 'Added Cyber' : 'Add Cyber'}}
        </button>
      }
    </div>
    <div class="selection-btn">
      @if (product.displayProduct) {
        <button class="selection-btn-btn" value="{{product.productId}}" [ngClass]="product.selected ? 'Added' : 'Add'"
          (click)="selectProduct(product)">
          {{ product.selected ? 'Selected' : 'Select'}}
        </button>
      }
      @if (!product.displayProduct) {
        <span class="selection-btn-text">Not Available</span>
      }
    </div>
  </div>
</div>